import { z } from 'zod';
import { coords, objectIdStr } from './common.js';
import { stationKey } from './station.js';

/**
 * Scans are evidence, not state (SPEC §4): positive-only, sparse, append-only. They
 * never move a booking and never write `actual.status`.
 */
export const scan = z.object({
  _id: objectIdStr,
  qrText: z.string().min(1),
  jobId: objectIdStr.optional(),
  batchId: objectIdStr.optional(),
  partId: objectIdStr.optional(),
  componentCode: z.string().optional(),
  stationKey: stationKey.optional(),
  user: z.string(),
  at: z.coerce.date(),
  location: z.union([coords, z.string()]).optional(),
});
export type Scan = z.infer<typeof scan>;

export const scanCreate = z.object({
  qrText: z.string().min(1),
  /** Defaults to the scanning user's own `stationKey` when omitted. */
  stationKey: stationKey.optional(),
  coords: coords.optional(),
});
export type ScanCreate = z.infer<typeof scanCreate>;

export const scanResult = z.object({
  status: z.enum(['recorded', 'duplicate', 'unknown']),
  message: z.string(),
  qrText: z.string(),
  jobName: z.string().optional(),
  batchName: z.string().optional(),
  partCode: z.string().optional(),
  partName: z.string().optional(),
  componentCode: z.string().optional(),
  componentName: z.string().optional(),
  stationKey: stationKey.optional(),
  cooldownSeconds: z.number().optional(),
});
export type ScanResult = z.infer<typeof scanResult>;
